import { useEffect, useRef } from "react";

const useInterval = (callback: () => void, interval: number) => {
    const savedCallback = useRef(() => {});
    const startDateTimeRef = useRef(new Date().getTime());
    savedCallback.current = callback;

    useEffect(() => {
        const shortInterval = interval > 1000 ? 1000 : interval;

        const intervalId = setInterval(() => {
            if (interval < 1000) {
                savedCallback.current();
                return;
            }

            const elapsed = new Date().getTime() - startDateTimeRef.current;
            if (elapsed > interval) {
                startDateTimeRef.current = new Date().getTime();
                savedCallback.current();
            }
        }, shortInterval);

        return () => {
            clearInterval(intervalId);
        };
    }, [interval]);
};

export default useInterval;
